export enum ExamToolIdentifier {
	Ruler,
	Protractor
}
